export type ICancellationReason = {
  id: string
  text: string
  children?: ICancellationReasonChild[]
}

export type ICancellationReasonChild = {
  id?: string
  text: string
  children?: ICancellationReasonChild[]
}

export const cancellationReasons: ICancellationReason[] = [
  {
    id: "Money",
    text: "Pricing, costs and money",
    children: [
      {
        id: "Found a better deal",
        text: "The customer found a cheaper deal at a different supplier",
        children: [
          {
            id: "British Gas",
            text: "British Gas",
          },
          {
            id: "Eon",
            text: "Eon",
          },
          {
            id: "Octopus",
            text: "Octopus",
          },
          {
            id: "EDF",
            text: "EDF",
          },
          {
            id: "Scottish Power",
            text: "Scottish Power",
          },
          {
            id: "OVO",
            text: "OVO",
          },
          {
            id: "SSE",
            text: "SSE",
          },
          {
            id: "Other",
            text: "Other",
          },
        ],
      },
      {
        id: "Fees from previous supplier",
        text: "The customer will be charged exit fees from their current supplier",
      },
      {
        id: "Current supplier winback",
        text: "The current supplier offered a better deal to win back the customer",
      },
    ],
  },
  {
    id: "Service",
    text: "Unhappy with the service so far",
    children: [
      {
        id: "Incorrect details",
        text: "The customer details are incorrect and couldn't be corrected",
      },
      {
        id: "Too many emails",
        text: "The customer received too many emails",
      },
      {
        id: "Changed mind",
        text: "The customer has changed their mind",
      },
      {
        id: "Sales quote was wrong",
        text: "The sales quote was wrong and the customer didn't like the accurate quote",
      },
      {
        id: "Never wanted to switch",
        text: "The customer didn’t want to switch to So Energy, it was a mistake",
      },
      {
        id: "Experienced poor customer service",
        text: "The customer experienced poor customer service",
      },
      {
        id: "Didn't have enough information",
        text: "The customer felt we didn't provide enough information about the switch",
      },
    ],
  },
  {
    id: "Failed DD setup",
    text: "Failed DD setup",
  },
  {
    id: "Other issues",
    text: "Had or predict other issues",
    children: [
      {
        id: "Additional needs",
        text: "The customer has additional needs, which we don't cater for",
      },
      {
        id: "Smart meter issues",
        text: "The customer has ongoing smart meter issues at their current supplier",
      },
      {
        id: "Technical issues",
        text: "The customer experienced technical issues when signing up to So Energy",
      },
    ],
  },
  {
    id: "Other",
    text: "Other",
  },
  {
    id: "Waiting on reason",
    text: "Waiting on customer cancellation reason",
  },
]
